import { render, staticRenderFns } from "./talentListComp.vue?vue&type=template&id=d6050f42&scoped=true"
import script from "./talentListComp.vue?vue&type=script&lang=js"
export * from "./talentListComp.vue?vue&type=script&lang=js"
import style0 from "./talentListComp.vue?vue&type=style&index=0&id=d6050f42&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6050f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6050f42')) {
      api.createRecord('d6050f42', component.options)
    } else {
      api.reload('d6050f42', component.options)
    }
    module.hot.accept("./talentListComp.vue?vue&type=template&id=d6050f42&scoped=true", function () {
      api.rerender('d6050f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/talentListComp.vue"
export default component.exports